export type GlobalMessageType = "success" | "error" | "info" | "warning";

export enum GlobalMessageEnum {
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning"
}

